import { useState } from 'react';
import { Icon } from './Icon';

export function PasswordInput({
  id,
  value,
  onChange,
  invalid,
  autoComplete,
  describedBy,
}: {
  id: string;
  value: string;
  onChange: (v: string) => void;
  invalid?: boolean;
  autoComplete: 'current-password' | 'new-password';
  describedBy?: string;
}) {
  const [show, setShow] = useState(false);
  return (
    <div className={invalid ? 'input err' : 'input'}>
      <input
        id={id}
        className="qin"
        type={show ? 'text' : 'password'}
        autoComplete={autoComplete}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-invalid={invalid || undefined}
        aria-describedby={describedBy}
      />
      <button
        type="button"
        className="btn icon g"
        style={{ minHeight: 36, height: 36, width: 36, marginRight: -6 }}
        aria-label={show ? 'Ocultar senha' : 'Mostrar senha'}
        aria-pressed={show}
        onClick={() => setShow((s) => !s)}
      >
        <Icon name={show ? 'eyeOff' : 'eye'} />
      </button>
    </div>
  );
}
